module.exports = __webpack_public_path__ + "img/close.ab96b7a8.png";